
<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>

        <a-form-item label="核销门店" name='store_name'>
          <a-input v-model:value="search.store_name" placeholder="请输入核销门店" />
        </a-form-item>
        <a-form-item label="所属上级" name='dealer_name'>
          <a-input v-model:value="search.dealer_name" placeholder="请输入所属上级" />
        </a-form-item>
        <a-form-item label="提货券名称" name='voucher_name'>
          <a-input v-model:value="search.voucher_name" placeholder="请输入关键词进行搜索" />
        </a-form-item>
        <a-form-item label="核销时间" name='time'>
          <a-range-picker v-model:value="search.time" valueFormat='YYYY-MM-DD' format='YYYY-MM-DD' @change="changTime" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit' class='m-r-10'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-40'>
        <a-table :pagination='false' :loading='listLoading' bordered  :columns='columns' :data-source='list'>
          <template v-slot:action="{ record }">
            <a v-has:pickUpStoreStatics="()=> {$router.push('/assets/coupons/pickUpCoupon/storeDetail?store_id='+record.store_id)}" href="javascript:;">详情</a>
          </template>
        </a-table>
        <a-pagination :style="{marginTop:'20px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" :show-total="total => `总数: ${total} `"  />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { iscode } from "@/utils/app";
import { getStoreVoucherwriteoffList } from "@/api/assets.js";
const def = {
  page: 1,
  limit: 10,
  voucher_name: "",
  store_name: "",
  start_time: "",
  dealer_name:'',
  end_time: "",
};
export default {
  components: {},
  name: "detail",
  setup() {
    const state = reactive({
      listLoading: false,
      total: 0,
    });
    let list = ref();
    let columns = [
      {
        title: "门店ID",
        dataIndex: "store_id",
        key: "store_id",
      },
      {
        title: "核销门店",
        dataIndex: "store_name",
        key: "store_name",
      },
      {
        title: "所属上级",
        dataIndex: "dealer_name",
        key: "dealer_name",
      },
      {
        title: "核销数量",
        dataIndex: "num",
        key: "num",
      },
      {
        title: "操作",
        key: "action",
        slots: { customRender: "action" },
      },
    ];
    //获取列表
    const initData = async (values) => {
      state.listLoading = true;
      let res = await getStoreVoucherwriteoffList({
        ...values,
      }).then((res) => res.data);
      if (iscode(res)) {
        list.value = res.data.data;
        state.total = res.data.total;
      }
      state.listLoading = false;
    };
    const $Modal = inject("$Modal");

    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const changTime = (e) => {
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    const inputSelect = (e) => {
      search.value.keyword = "";
    };
    onMounted(() => {
      initData(search.value);
    });
    // 导出
    const exportTable = async () => {
      let res = await getStoreVoucherwriteoffList({
        ...search.value,
        excel: 1,
      }).then((res) => res.data);
      if (iscode(res, true)) {
        window.open(res.data.action);
      }
    };
    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      changTime,
      inputSelect,
      exportTable,
    };
  },
};
</script>